import React, { useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import { showNotificationAutoDestroy } from '../../../shared/components/ShowNotification';
import {
  changeLoadingTrue,
  changeLoadingFalse,
} from '../../../redux/actions/loadingActions';
import GraphQL from '../../../GraphQL';
import SmartCard from '../../../shared/components/SmartCard';
import ReportCardView from './ReportCardView';
import ModalForm from './ModalForm';
import BuilderFormStudentReportCard from './BuilderFormStudentReportCard';
import Modal from '../../../shared/components/Modal';
import LeftContainer from './LeftContainer';
import listUnconsolidatedCycleClosingForField, {
  findCycleEndingById,
  listConsolidatedCycleClosing,
} from '../../../shared/queries/ConsolidationCycleClosing';
import { classListByCourseStagePeriod } from '../../../shared/queries/SchoolClass';
import {
  schoolReportSaveMutation,
  schoolReportRemoveMutation,
  listSchoolReportForPrint,
} from '../../../shared/queries/ReportCard';
import {
  RELATION_OBJECT_TYPE,
  STATUS_RELEASED,
} from '../../../shared/utils/constants';

const ReportCardHandler = (props) => {
  const { match, t, history, dispatch } = props;

  const [studentReportCardForm, setStudentReportCardForm] = useState(false);
  const [disciplinesLacking, setDisciplinesLacking] = useState([]);
  const [schoolClasses, setSchoolClasses] = useState([]);
  const [closure, setClosure] = useState({});
  const [editable, setEditable] = useState(false);
  const [selectedDataToRemove, setSelectedDataToRemove] = useState({});

  const [reportCardRelease, setReportCardRelease] = useState(false);
  const [reportCardRemove, setReportCardRemove] = useState(false);
  const [selectedSchoolClass, setSelectedSchoolClass] = useState();
  const [reportCardWrapper, setReportCardWrapper] = useState({
    students: [],
    subjects: [],
  });
  const [studentsForReportCardPrint, setStudentsForReportCardPrint] = useState(
    []
  );

  const backClickHandler = () => {
    history.push('/minime/fechamento-ciclo');
  };

  const showLoading = () => {
    dispatch(changeLoadingTrue());
  };

  const hideLoading = () => {
    dispatch(changeLoadingFalse());
  };

  const toggleStudentReportCardForm = () => {
    setStudentReportCardForm(!studentReportCardForm);
  };

  const studentsBySchoolClass = (schoolClass) => {
    const query = listSchoolReportForPrint(schoolClass.id, closure.cycleNumber);
    GraphQL(query, {})
      .then((res) => {
        res.schoolReportListByClassAndCycle =
          res.schoolReportListByClassAndCycle.map((item) => ({
            ...item,
            value: item.id,
            label: item.student.label,
          }));
        const sendAll = {
          label: RELATION_OBJECT_TYPE.ALL,
          value: RELATION_OBJECT_TYPE.ALL,
        };
        res.schoolReportListByClassAndCycle.push(sendAll);
        setStudentsForReportCardPrint(res.schoolReportListByClassAndCycle);
        toggleStudentReportCardForm();
      })
      .catch(() => {});
  };

  const toggleReportCardRelease = () => {
    setReportCardRelease(!reportCardRelease);
  };

  const toggleRemoveReportCard = (selectedClass, studentsReports) => {
    const schoolReportToRemove =
      studentsReports &&
      studentsReports.map((report) => ({
        id: report.reportId,
        cycleEndingId: closure.id,
        schoolClass: {
          id: selectedClass.id,
          studentsQuantity: 0,
          updaterId: 0,
          year: 0,
          active: true,
        },
      }));
    setSelectedDataToRemove(schoolReportToRemove);
    setReportCardRemove(!reportCardRemove);
  };

  const loadUnconsolidatedCycleClosing = (
    cycleNumber,
    classId,
    schoolTermId
  ) => {
    showLoading();
    const query = listUnconsolidatedCycleClosingForField(
      cycleNumber,
      classId,
      schoolTermId
    );
    GraphQL(query, {})
      .then((res) => {
        setDisciplinesLacking([...res.listUnconsolidatedCycleClosing]);
        hideLoading();
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('notifications.error'),
          t('errors.error-to-load')
        );
      });
  };

  const loadClassListByCourseStagePeriod = (
    courseId,
    courseStepId,
    schoolTerm,
    cycle
  ) => {
    showLoading();
    const query = classListByCourseStagePeriod(
      courseId,
      courseStepId,
      schoolTerm,
      cycle
    );
    GraphQL(query, {})
      .then((res) => {
        hideLoading();
        setSchoolClasses([...res.classListByCourseStagePeriod]);
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('notifications.error'),
          t('errors.error-to-load')
        );
      });
  };

  const loadListConsolidatedCycleClosing = (cycle, classId, statusClass) => {
    showLoading();
    const query = listConsolidatedCycleClosing(cycle, classId, statusClass);
    GraphQL(query, {})
      .then((res) => {
        setReportCardWrapper({ ...res.listConsolidatedCycleClosing });
        hideLoading();
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('notifications.error'),
          t('errors.error-to-load')
        );
      });
  };

  const findById = (id) => {
    showLoading();
    const query = findCycleEndingById(id);
    GraphQL(query, {})
      .then((res) => {
        hideLoading();
        if (res.findCycleEndingById) {
          setClosure({ ...res.findCycleEndingById });
          loadClassListByCourseStagePeriod(
            res.findCycleEndingById.course.id,
            res.findCycleEndingById.courseStep.id,
            res.findCycleEndingById.period.id,
            res.findCycleEndingById.cycleNumber
          );
        } else {
          showNotificationAutoDestroy(
            'danger',
            t('notifications.error'),
            t('notifications.record-not-found')
          );
          backClickHandler();
        }
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const handleSubmit = (status) => {
    showLoading();
    if (reportCardRelease) {
      toggleReportCardRelease();
    }
    const query = schoolReportSaveMutation(
      {
        selectedSchoolClass,
        reportCardWrapper,
        closure,
      },
      status
    );
    GraphQL(query, {})
      .then(() => {
        hideLoading();
        backClickHandler();
        showNotificationAutoDestroy(
          'success',
          t('success.title'),
          t('success.successfully-saved')
        );
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('notifications.error'),
          t('errors.error-to-save')
        );
      });
  };

  const loadReportCardBySchoolClass = (schoolClass) => {
    loadUnconsolidatedCycleClosing(
      closure.cycleNumber,
      schoolClass.id,
      closure.period.id
    );
    loadListConsolidatedCycleClosing(
      closure.cycleNumber,
      schoolClass.id,
      schoolClass.status
    );
  };

  const updateDisciplinesLackingOnBlur = () => {
    const reportCardClone = { ...reportCardWrapper };
    const updatedDisciplinesLacking = reportCardClone.students
      .reduce((acc, item) => acc.concat(item.data), [])
      .filter(
        (item) =>
          item.frequency === null ||
          item.average === null ||
          item.absences === null
      )
      .filter(
        (item, index, clone) =>
          clone.findIndex(({ id }) => id === item.id) === index
      )
      .map((item) => ({
        ...item,
        value: item.id,
        label: item.name,
      }));
    setDisciplinesLacking(updatedDisciplinesLacking);
  };

  const toggleEditable = () => {
    loadReportCardBySchoolClass(selectedSchoolClass);
    if (!editable) {
      setEditable(!editable);
    }
  };

  const handleRemove = () => {
    showLoading();
    setReportCardRemove(!reportCardRemove);
    const removeMutation = schoolReportRemoveMutation(selectedDataToRemove);
    GraphQL(removeMutation, {})
      .then(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'success',
          t('success.title'),
          t('success.successfully-removed')
        );
        backClickHandler();
      })
      .catch((e) => {
        console.error(e);
        hideLoading();
        backClickHandler();
      });
  };

  useEffect(() => {
    if (editable) {
      setEditable(false);
    }
  }, [selectedSchoolClass]);

  useEffect(() => {
    findById(match.params.id);
  }, []);

  return (
    <SmartCard title={t('panels.cycle-closing')}>
      {reportCardRelease && (
        <Modal
          color="warning"
          title={t('notifications.attention')}
          btn="Warning"
          message={t('notifications.report-card-releasing')}
          toggle={toggleReportCardRelease}
          modal={reportCardRelease}
          onConfirm={() => handleSubmit(STATUS_RELEASED)}
        />
      )}
      {reportCardRemove && (
        <Modal
          color="warning"
          title={t('notifications.attention')}
          btn="Warning"
          message={t('notifications.delete_modal')}
          toggle={toggleRemoveReportCard}
          modal={reportCardRemove}
          onConfirm={handleRemove}
        />
      )}
      {studentReportCardForm && (
        <ModalForm
          formBuilder={
            <BuilderFormStudentReportCard
              close={toggleStudentReportCardForm}
              students={studentsForReportCardPrint}
              selectedClass={selectedSchoolClass}
            />
          }
          title={t('general.student-report-card')}
          isOpen={studentReportCardForm}
        />
      )}
      {closure.course && (
        <div className="report-card-container">
          <LeftContainer
            closure={closure}
            schoolClasses={schoolClasses}
            changeSelectedSchoolClass={setSelectedSchoolClass}
            selectedSchoolClass={selectedSchoolClass}
          />
          <ReportCardView
            backHandler={backClickHandler}
            changeReportCardWrapper={setReportCardWrapper}
            toggleStudentReportCardForm={studentsBySchoolClass}
            toggleReportCardRelease={toggleReportCardRelease}
            toggleRemoveReportCardForm={toggleRemoveReportCard}
            disciplinesLacking={disciplinesLacking}
            selectedSchoolClass={selectedSchoolClass}
            reportCardWrapper={reportCardWrapper}
            closure={closure}
            updateDisciplinesLackingOnBlur={updateDisciplinesLackingOnBlur}
            loadReportCardBySchoolClass={loadReportCardBySchoolClass}
            toggleEditable={toggleEditable}
            editable={editable}
            setEditable={setEditable}
            changeDisciplinesLacking={setDisciplinesLacking}
            saveReportCard={handleSubmit}
          />
        </div>
      )}
    </SmartCard>
  );
};

ReportCardHandler.propTypes = {
  t: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  match: ReactRouterPropTypes.match.isRequired,
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(ReportCardHandler)
);
